import { Page } from '@/core/architecture'

import { ConsoleCollectionDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleCollectionDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleCollectionDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleCollectionDetailTemplate state={state} {...actions} />
}
